"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_uid_1 = require("react-uid");
const progressBarWidth = 10;
const ProgressBarContainer = styled_components_1.default.div `
  max-width: 22.8vmin;
  height: 3.3vmin;
  background-color: rgba(0, 0, 0, 0.45);
  border-radius: 2vmin;
  position: absolute;
  bottom: 2.2vmin;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  justify-content: left;
  padding: 0 0.6vmin;
  visibility: ${(props) => (props.currentSlideHasVideo ? "hidden" : "visible")};
  z-index: 3;

  .spacing {
    margin: 0 0.6vmin;
  }

  .filled-bar {
    height: 100%;
    background-color: #ffffff;
    max-width: ${progressBarWidth}vmin;

    width: 20%;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 20px;
    z-index: 99;
  }
`;
const ProgressBarDot = styled_components_1.default.div `
  width: 1vmin;
  height: 1vmin;
  border-radius: 50%;
  background-color: #ffffff;
  opacity: 0.5;
`;
const ProgressBarSmallDot = styled_components_1.default.div `
  width: 0.8vmin;
  height: 0.8vmin;
  border-radius: 50%;
  background-color: #ffffff;
  opacity: 0.5;
`;
const ProgressBarDorExpanded = styled_components_1.default.div `
  width: ${progressBarWidth}vmin;
  height: 1vmin;
  border-radius: 2vmin;
  background-color: rgba(255, 255, 255, 0.5);
  position: relative;
`;
const MAX_NUMBER_DOTS_PROGRESSBAR = 6;
const ProgressBar = (props) => {
    const { numberOfSlides, slideDuration, currentSlideIndex, currentSlideHasVideo, } = props;
    const [fillPercent, setFillPercent] = (0, react_1.useState)(0);
    const progressBarInterval = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        if (progressBarInterval.current) {
            clearInterval(progressBarInterval.current);
        }
        setFillPercent(0);
        progressBarInterval.current = setInterval(() => {
            setFillPercent((currentPercentage) => {
                if (currentPercentage >= 100) {
                    clearInterval(progressBarInterval.current);
                    return 100;
                }
                return currentPercentage + 1;
            });
        }, slideDuration / 100);
    }, [currentSlideIndex, slideDuration]);
    (0, react_1.useEffect)(() => () => {
        clearInterval(progressBarInterval.current);
    }, []);
    const generateProgressBarDots = () => {
        const dots = new Array(numberOfSlides < MAX_NUMBER_DOTS_PROGRESSBAR
            ? numberOfSlides
            : MAX_NUMBER_DOTS_PROGRESSBAR)
            .fill("dot")
            .map((dot, index) => {
            const isBeginingDot = index % MAX_NUMBER_DOTS_PROGRESSBAR === 0 &&
                currentSlideIndex > MAX_NUMBER_DOTS_PROGRESSBAR / 2 - 1 &&
                numberOfSlides > MAX_NUMBER_DOTS_PROGRESSBAR;
            const isEndingDot = index === MAX_NUMBER_DOTS_PROGRESSBAR - 1 &&
                numberOfSlides - currentSlideIndex >
                    MAX_NUMBER_DOTS_PROGRESSBAR / 2 - 1;
            if (numberOfSlides <= 6) {
                if (index === currentSlideIndex) {
                    return (react_1.default.createElement(ProgressBarDorExpanded, { key: (0, react_uid_1.uid)(index), className: "spacing" },
                        react_1.default.createElement("div", { className: "filled-bar", style: { width: `${fillPercent}%` } })));
                }
            }
            else {
                if (currentSlideIndex < MAX_NUMBER_DOTS_PROGRESSBAR / 2 - 1) {
                    if (index === currentSlideIndex) {
                        return (react_1.default.createElement(ProgressBarDorExpanded, { key: (0, react_uid_1.uid)(index), className: "spacing" },
                            react_1.default.createElement("div", { className: "filled-bar", style: { width: `${fillPercent}%` } })));
                    }
                }
                else if (index === MAX_NUMBER_DOTS_PROGRESSBAR / 2 - 1 &&
                    numberOfSlides - currentSlideIndex > 3) {
                    return (react_1.default.createElement(ProgressBarDorExpanded, { key: (0, react_uid_1.uid)(index), className: "spacing" },
                        react_1.default.createElement("div", { className: "filled-bar", style: { width: `${fillPercent}%` } })));
                }
                if (index ===
                    MAX_NUMBER_DOTS_PROGRESSBAR -
                        (numberOfSlides - currentSlideIndex) &&
                    index > MAX_NUMBER_DOTS_PROGRESSBAR / 2 - 1) {
                    return (react_1.default.createElement(ProgressBarDorExpanded, { key: (0, react_uid_1.uid)(index), className: "spacing" },
                        react_1.default.createElement("div", { className: "filled-bar", style: { width: `${fillPercent}%` } })));
                }
            }
            if (isBeginingDot || isEndingDot) {
                return react_1.default.createElement(ProgressBarSmallDot, { key: (0, react_uid_1.uid)(index), className: "spacing" });
            }
            return react_1.default.createElement(ProgressBarDot, { key: (0, react_uid_1.uid)(index), className: "spacing" });
        });
        return dots;
    };
    return (react_1.default.createElement(ProgressBarContainer, { currentSlideHasVideo: currentSlideHasVideo }, generateProgressBarDots()));
};
exports.default = ProgressBar;
